<div #siSelector id="si-selector-{{id}}" class="si-selector {{styleClass}}"
     [class.disabled]="disabled"
     [class.invalid]="formModel.invalid && (formModel.dirty || formModel.formDirective?.submitted)"
     [class.open-top]="openTop && isDesktop">
  <div class="si-selector_container" *ngIf="!hideLabel">
    <div class="si-selector_container_label">
      <si-label [text]="text"
                [tooltipText]="tooltipText"
                [tooltipPosition]="tooltipPosition"
                [tooltipIcon]="tooltipIcon"
                [tooltipStyleClass]="tooltipStyleClass"
                [tooltipEscape]="tooltipEscape"
                [forceShowTooltipIcon]="forceShowTooltipIcon"
                (tooltipIconClick)="onClickTooltipIcon($event)"
                forId="si-selector_dropdown-{{id}}"
      ></si-label>
    </div>
    <i *ngIf="showAlert" class="si-selector_alert icon-nottoday"
       pTooltip="{{alertTooltipText | translate}}" tooltipPosition="top" tooltipStyleClass="red">
    </i>
  </div>
  <div class="si-selector_dropdown" siProvideParentForm
       [class.si-selector_dropdown_no-clear]="!showClear">
    <p-dropdown #pDropdown #formModel="ngModel"
                inputId="si-selector_dropdown-{{id}}"
                [options]="options"
                [(ngModel)]="model"
                [name]="name"
                [placeholder]="disabled ? '' : placeholderTranslated"
                [filter]="showDropdownSearch"
                [styleClass]="dropdownStyleClass"
                [scrollHeight]="scrollHeight"
                [autoDisplayFirst]="false"
                [disabled]="disabled"
                [autofocusFilter]="autofocusFilter"
                [resetFilterOnHide]="true"
                [showClear]="showClear"
                (onChange)="onChangeDropdownOption($event)"
                (onClick)="onClickDropdown()"
                (onHide)="onHideDropdown()"
                (onFocus)="onFocusDropdown()"
                (onShow)="onShowDropdown()"
                siValidation="{{rule}}"
                [siValidationElement]="validationElement"
                [siValidationExternalErrorText]="validationExternalErrorText"
                aria-live="assertive">
      <ng-template let-outerContext *ngIf="selectedItem" pTemplate="selectedItem">
        <ng-container *ngTemplateOutlet="selectedItem; context: {$implicit: outerContext}"></ng-container>
      </ng-template>
      <ng-template let-outerContext *ngIf="item" pTemplate="item">
        <ng-container *ngTemplateOutlet="item; context: {$implicit: outerContext}"></ng-container>
      </ng-template>
      <ng-template pTemplate="empty">
        <span *ngIf="optionsLoaded">{{'primeng.emptyMessage' | translate}}</span>
      </ng-template>
      <ng-template pTemplate="emptyfilter">
        <span *ngIf="optionsLoaded">{{'primeng.emptyFilterMessage' | translate}}</span>
      </ng-template>
    </p-dropdown>
    <div #siSelectorLoader class="si-selector_dropdown_loader"><i class="icon-spinner"></i></div>
    <si-validation-element #validationElement
                           [formModel]="formModel"
                           [showErrorText]="!showRuleErrorOutsideIcon"
                           (errorTextChange)="validationErrorText = $event"
                           class="si-selector_dropdown_validation"
    ></si-validation-element>
  </div>
  <div *ngIf="showRuleErrorOutsideIcon">
    <si-validation-error-text [text]="validationErrorText || validationExternalErrorText"
                              [formModel]="formModel"
    ></si-validation-error-text>
  </div>
</div>
